import { render } from "./ConfigurarFichaEpi.vue?vue&type=template&id=b5e4aa5c&scoped=true"
import script from "./ConfigurarFichaEpi.vue?vue&type=script&lang=js"
export * from "./ConfigurarFichaEpi.vue?vue&type=script&lang=js"

import "./ConfigurarFichaEpi.vue?vue&type=style&index=0&id=b5e4aa5c&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5e4aa5c"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QFile from 'quasar/src/components/file/QFile.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QEditor from 'quasar/src/components/editor/QEditor.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QBtn,QCard,QFile,QSelect,QEditor,QCheckbox,QDialog,QCardSection,QSpace,QImg,QSeparator,QTable,QCardActions});qInstall(script, 'directives', {ClosePopup});
